import React from 'react';
import { Mask } from 'antd-mobile';
import style from './modal.module.scss';

interface Props {
  visible: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  hideCloseIcon?: boolean;
  title?: string;
  okText?: string;
  onOk?: () => void;
  cancelText?: string;
  onCancel?: () => void;
  containerStyle?: React.CSSProperties;
  footContent?: React.ReactNode;
}

export default function MMDialog({
  visible,
  onRequestClose,
  children,
  okText,
  onOk,
  cancelText,
  onCancel,
  title,
  containerStyle = {},
  footContent,
  hideCloseIcon = false,
}: Props) {
  return (
    <Mask getContainer={() => document.body} onMaskClick={onRequestClose} visible={visible}>
      <div
        style={{
          position: 'relative',
          width: '100vw',
          height: '100vh',
        }}
        onClick={onRequestClose}
      >
        <div className={style.modalContent} onClick={(e) => e.stopPropagation()} style={containerStyle}>
          {!hideCloseIcon && <div className={style.closeIcon} onClick={onRequestClose} />}
          {!!title && <div className={style.title}>{title}</div>}
          <div className={style.content}>{children}</div>
          <div className={style.bottom}>
            {!!cancelText && (
              <div className={style.cancel} onClick={onCancel ?? onRequestClose}>
                {cancelText}
              </div>
            )}
            {!!cancelText && !!okText && <div style={{ width: 20 }}></div>}
            {!!okText && (
              <div className={style.ok} onClick={onOk ?? onRequestClose}>
                {okText}
              </div>
            )}
          </div>
          {footContent ? footContent : null}
        </div>
      </div>
    </Mask>
  );
}
